/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionplacecardopen3Inputs */

const en_actionplacecardopen3 = /** @type {(inputs: Actionplacecardopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send an action`)
};

const de_actionplacecardopen3 = /** @type {(inputs: Actionplacecardopen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion schalten`)
};

/**
* | output |
* | --- |
* | "Send an action" |
*
* @param {Actionplacecardopen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionplacecardopen3 = /** @type {((inputs?: Actionplacecardopen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionplacecardopen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionplacecardopen3(inputs)
	return de_actionplacecardopen3(inputs)
});
export { actionplacecardopen3 as "actionPlaceCardOpen" }